let watches = [];
let selectedWatch = null;

async function getWatches() {
    try {
        const response = await fetch('https://pub-697dc9ec09b74369958d54a1cf851168.r2.dev/watches.json');
        return await response.json();
    } catch (error) {
        console.error('Error fetching R2 data:', error);
    }
}

document.addEventListener("DOMContentLoaded", async function () {
    let watchData = await getWatches();
    if (!watchData) return;

    // 1. Parse the R2 data
    watchData.forEach(object => {
        watches.push({
            "handle": object.handle,
            "id": object.id,
            "manufacturer": object.fields[0].value,
            "model": object.fields[1].value,
            "size": object.fields[2].value,
            "variants": JSON.parse(object.fields[3].value) 
        });
    });

    // 2. Fetch variant details from our NEW Liquid Template (Zero tokens needed)
    // We fetch products associated with the watches to get their titles/handles
    try {
        const response = await fetch(`/search?view=watch-data&type=product&q=id:*`);
        const shopifyData = await response.json();
        
        // Map the data for easy lookup
        let variantMap = {};
        shopifyData.results.forEach(v => {
            variantMap[v.id] = v;
        });

        // 3. Update watches with the real Shopify data
        watches.forEach(watch => {
            let enrichedVariants = [];
            watch.variants.forEach(vID => {
                // The R2 uses "gid://shopify/ProductVariant/12345", we need just "12345"
                const cleanID = vID.includes('Variant/') ? vID.split('Variant/').pop() : vID;
                if (variantMap[cleanID]) {
                    enrichedVariants.push(variantMap[cleanID]);
                }
            });
            watch.variants = enrichedVariants;
        });

    } catch (e) {
        console.error("Error enrichment:", e);
    }

    document.dispatchEvent(new Event('watchesLoaded'));
    console.log("Watches fully loaded and enriched", watches);
});